<template>
  <el-dialog
    title="应收减免"
    :visible.sync="dialogVisible"
    width="824px"
    :before-close="closeDialog"
    destroy-on-close
  >
    <div slot="title">
      <span>应收减免</span>
      <el-tooltip
        class="item"
        content="车辆入库后，由系统创建的应收单操作减免，车辆交接时间将不可修改"
        placement="right"
        ><i class="el-icon-question"></i>
      </el-tooltip>
    </div>

    <el-form ref="form" :model="params" :rules="rules" :inline="true">
      <el-row :gutter="24">
        <el-col :span="8">
          <el-form-item prop="id" label="应收ID:">
            <span>{{ params.id || '--' }}</span>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item prop="itemAmount" label="款项金额:">
            <span>{{ params.itemAmount || '--' }}</span>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item prop="itemAmount" label="剩余应收金额:">
            <span>{{ params.remainAmount || '--' }}</span>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item prop="relieveAmount" label="减免金额:">
        <el-input
          v-model="params.relieveAmount"
          v-number:money
          placeholder="请输入"
          @change="deductionAmountChange"
        >
        </el-input>
      </el-form-item>
      <el-form-item prop="remark" label="备注:">
        <el-input
          v-model="params.remark"
          type="textarea"
          maxlength="500"
          show-word-limit
          placeholder="请输入"
        ></el-input>
      </el-form-item>
      <el-form-item prop="attachment" label="减免凭证:">
        <UploadCommon
          fileTitle="减免凭证"
          :multiple="true"
          :limit="6"
          :fileList.sync="params.attachment"
          :sizeType="4"
          listType="text"
          commonUpload
          group="finance"
          code="finance_reduction_agreement_pic"
        >
        </UploadCommon>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">取 消</el-button>
      <el-button v-if="!dingTalkShow" type="primary" @click="confirmBtn"
        >确 定</el-button
      >
      <el-button v-else type="primary" @click="sunbmitDdApprove"
        >提交钉钉审批</el-button
      >
    </span>
    <!-- 钉钉审批异常弹窗 -->
    <approve-validate-dialog
      ref="approveValidateDialogRef"
      :dingTalkShow="dingTalkShow"
      :sunbmitFun="addDeductionAmount"
      @reloadClick="getDingTalkBtnStatus"
      :tableData="[row.id]"
      :isSubmitOther="false"
    />
  </el-dialog>
</template>

<script>
import { addReceivableConfirm } from '@/api/financeApi'
import { getSubmitDingTalkShow } from '@/api/global'
import ApproveValidateDialog from '../../components/ApproveValidateDialog'

export default {
  model: {
    prop: 'showDialog',
    event: 'change',
  },
  components: {
    ApproveValidateDialog,
  },
  data() {
    return {
      dialogVisible: false,
      params: {
        id: '',
        itemAmount: '',
        relieveAmount: '',
        remark: '',
        remainAmount: '',
        attachment: [], // 减免凭证
      },
      rules: {
        relieveAmount: [
          { required: true, message: '减免金额不能为空', trigger: 'change' },
        ],
        remark: [{ required: true, message: '备注不能为空', trigger: 'blur' }],
        attachment: [
          { required: true, message: '减免凭证不能为空', trigger: 'change' },
        ],
      },
      dingTalkShow: false,
    }
  },
  props: {
    showDialog: {
      type: Boolean,
      default: false,
    },
    row: {
      type: Object,
      default: () => ({}),
    },
  },
  watch: {
    showDialog(val) {
      this.dialogVisible = val
    },
    dialogVisible(val) {
      this.$emit('change', val)
      if (val) {
        this.getDingTalkBtnStatus()
        const { id, itemAmount, remainAmount } = this.row
        this.params = Object.assign(this.params, {
          id,
          itemAmount,
          remainAmount,
        })
      }
    },
    'params.attachment': {
      handler() {
        this.$refs.form.validateField('attachment')
      },
      deep: true,
    },
  },
  methods: {
    confirmBtn() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.$refs.approveValidateDialogRef.receivableFilterReceivable()
        }
      })
    },
    // 提交钉钉审批
    sunbmitDdApprove() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          await this.getDingTalkBtnStatus()
          this.$refs.approveValidateDialogRef.sunbmitDdApprove()
        }
      })
    },
    // 查询钉钉审批是否开通
    async getDingTalkBtnStatus() {
      const params = {
        bizType: 12,
      }
      const { data } = await getSubmitDingTalkShow(params)
      this.dingTalkShow = data
    },
    deductionAmountChange() {
      // 减免金额只可输入 0<=X<=（款项金额-已收金额）
      if (
        this.params.relieveAmount >
        Number((this.row.itemAmount - this.row.receivedAmount).toFixed(2))
      ) {
        this.params.relieveAmount = Number(
          (this.row.itemAmount - this.row.receivedAmount).toFixed(2),
        )
      }
    },
    closeDialog() {
      this.$refs.form?.resetFields()
      this.dialogVisible = false
    },
    // 新增
    addDeductionAmount() {
      this.$refs.form.validate(async (valid) => {
        if (!valid) return
        const params = {
          ...this.params,
          approvalAccessModeType: (this.dingTalkShow && 2) || '',
          attachment:
            this.getUoloadCommonFileData(this.params.attachment) || null,
        }
        const { code } = await addReceivableConfirm(params)
        if (code !== 1) return
        this.$emit('searchHandle')
        this.closeDialog()
        const msg = this.dingTalkShow ? '发起审批成功' : '提交成功！'
        this.$message.success(msg)
        this.$refs.form.resetFields()
      })
    },
  },
  deactivated() {
    this.closeDialog()
  },
}
</script>

<style></style>
